import React from 'react'
import { connect as connectRedux } from 'react-redux'
import ImmutablePropTypes from 'react-immutable-proptypes'
import compose from 'recompose/compose'
import PropTypes from 'prop-types'
import { Map } from 'immutable'
import { getBoundActions } from '../../../actions/index'
import IconV2, { ICON_TYPES } from '../../Icon.v2/index'
import { connect as connectStaticText } from '../../StaticText/connect'

const MultiplePlaylistsShareTooltip = (props) => {
  const {
    auth,
    staticText,
    sharePlaylistTooltip,
    setFeatureTrackingDataPersistent,
  } = props

  const showShareTooltip = !sharePlaylistTooltip

  function dismissTooltip () {
    if (showShareTooltip) {
      setFeatureTrackingDataPersistent({
        data: Map({ sharePlaylistTooltip: true }),
        auth,
      })
    }
  }

  return (
    <div className="multiple-playlists-share-tooltip">
      <IconV2
        className="multiple-playlists-share-tooltip__close"
        type={ICON_TYPES.CLOSE}
        onClick={dismissTooltip}
      />
      <h6 className="multiple-playlists-share-tooltip__title">{staticText.getIn(['data', 'title'])}</h6>
      <p className="multiple-playlists-share-tooltip__body">{staticText.getIn(['data', 'body'])}</p>
    </div>
  )
}

MultiplePlaylistsShareTooltip.propTypes = {
  auth: ImmutablePropTypes.map.isRequired,
  sharePlaylistTooltip: PropTypes.bool,
  setFeatureTrackingDataPersistent: PropTypes.func.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
}
export default compose(
  connectStaticText({ storeKey: 'MultiplePlaylistsShareTooltip' }),
  connectRedux(
    (state) => ({
      auth: state.auth,
      sharePlaylistTooltip: state.featureTracking.getIn(['data', 'sharePlaylistTooltip'], false),
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setFeatureTrackingDataPersistent:
          actions.featureTracking.setFeatureTrackingDataPersistent,
      }
    },
  ),
)(MultiplePlaylistsShareTooltip)
